import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors, border }) => ({
  container: {
    flexDirection: "row",
    height: spacing(12),
    gap: {
      xs: spacing(2),
      xl: spacing(6),
    },
  },
  tab: ({ isActive }: { isActive: boolean }) => ({
    padding: spacing(3),
    borderRadius: border.radius.md,
    backgroundColor: isActive ? colors.backgroundFocus : "transparent",
    _web: {
      transition: "background-color 0.2s ease-out",
      _hover: {
        backgroundColor: isActive
          ? colors.backgroundFocus
          : colors.backgroundHover,
      },
      _focus: {
        outline: "none",
      },
      "_focus-visible": {
        outlineWidth: border.widths.md,
        outlineColor: colors.borderFocus,
        outlineOffset: border.widths.md,
        outlineStyle: "solid",
        borderRadius: border.radius.md,
      },
    },
  }),
  tabInner: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: {
      xs: spacing(1),
      xl: spacing(2),
    },
  },
  tabIcon: {
    width: spacing(6),
    height: spacing(6),
  },
  tabLabel: ({ isActive }: { isActive: boolean }) => ({
    color: isActive ? colors.foregroundOnInverted : colors.foregroundDefault,
  }),
}));

const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  icon: [
    { width: initialTheme.spacing(6), height: initialTheme.spacing(6) }, // for 1:1
  ],
};

export default stylesheet;
